export default __webpack_public_path__ + "static/media/video - extensions.896b9b88.mp4";